import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Home } from 'lucide-react';
import Header from '../components/Header';

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simular verificação do pagamento
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00A86B] mx-auto mb-4"></div>
            <p className="text-gray-600">Verificando pagamento...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="max-w-2xl mx-auto px-4 py-16">
        <Card className="p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-green-100 p-4">
              <CheckCircle size={64} className="text-green-600" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Pagamento Realizado com Sucesso!
          </h1>
          
          <p className="text-gray-600 mb-8">
            Obrigado pela sua compra! Seu pedido foi processado com sucesso.
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
            <h3 className="font-semibold text-gray-800 mb-2">Próximos Passos:</h3>
            <ul className="text-left text-sm text-gray-700 space-y-2">
              <li className="flex items-start">
                <span className="mr-2">✅</span>
                <span>Você receberá um email de confirmação com os detalhes do seu pedido.</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">✅</span>
                <span>Nossa equipe entrará em contato em até 24 horas úteis para dar continuidade ao processo.</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">✅</span>
                <span>Os documentos técnicos serão enviados para o seu email.</span>
              </li>
            </ul>
          </div>

          {sessionId && (
            <div className="text-sm text-gray-500 mb-6">
              ID da Transação: {sessionId.substring(0, 20)}...
            </div>
          )}

          <div className="flex gap-4 justify-center">
            <Button
              onClick={() => navigate('/')}
              className="bg-[#00A86B] hover:bg-[#008c5a] text-white px-8"
            >
              <Home size={20} className="mr-2" />
              Voltar para Home
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
